import React from 'react'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'

class Sectiontitle extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <h1 className={`section-title ${(this.props.color) ? this.props.color : ''}`}>
            { this.props.icon && 
                <FontAwesomeIcon icon={this.props.icon} />
            } {this.props.title}
            </h1>
        );
    }
}

export default Sectiontitle



// WEBPACK FOOTER //
// ./src/components/sectionTitle.js